module.exports = __webpack_public_path__ + "img/mizik-logo-02.8ead7831.png";